/** @format */

import template from './gb-edit-notification-widget.html';
import './gb-edit-notification-widget.scss';

import _ from 'lodash';
import faker from 'faker';

export const GbEditNotificationWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbEditTools: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbEditNotificationWidgetComponent {
        constructor($rootScope, $gbNotificationProjectorWidget, $gbItem, $ccLoading, LoadingHelper) {
            'ngInject';

            this.$rootScope = $rootScope;
            this.$gbNotificationProjectorWidget = $gbNotificationProjectorWidget;
            this.$gbItem = $gbItem;

            this.fakeNotifHeader = 'New Bid';
            this.fakeNotifBody = '5 nights for 2 people in Thailand';

            this.loadingHelper = new LoadingHelper();
            this.isLoading = () => this.loadingHelper.isLoading();
            this.getLoadingMessage = () => this.loadingHelper.getFirstMessage();
            this.loadingWatcher = $ccLoading.bind(this.isLoading, this.getLoadingMessage);
        }

        getWidget() {
            return this.widget;
        }

        getRandomItem() {
            let items = this.$gbItem.cache.query({
                auction: this.gbApp.getAuctionUrl(),
                item_type: 'bidding',
            });

            if (items) {
                return _.sample(items); // returns a random element from the array
            }
        }

        showPreviewNotif() {
            let fakeName = null;
            let fakeAmount = null;

            if (!this.getWidget().hide_name) {
                fakeName = `${faker.name.firstName()} ${faker.name.lastName()}`;
            }

            if (!this.getWidget().hide_price) {
                let amount = faker.datatype.number({
                    min: 1,
                    max: 1000,
                });

                amount *= 10;

                fakeAmount = `$${amount}`;
            }

            let item = this.getRandomItem();

            if (item) {
                let image = item && item.images && item.images[0] && item.images[0].image;

                this.previewNotif = {
                    widget: this.getWidget().uuid,
                    header: this.fakeNotifHeader,
                    body: item.name,
                    secondary_text_1: fakeName,
                    secondary_text_2: fakeAmount,
                    image: image,
                };
            } else {
                this.previewNotif = {
                    widget: this.getWidget().uuid,
                    header: this.fakeNotifHeader,
                    body: this.fakeNotifBody,
                    secondary_text_1: fakeName,
                    secondary_text_2: fakeAmount,
                    font_icon: 'mood',
                };
            }

            this.$rootScope.$broadcast(this.gbApp.$notifPreviewEvent, this.previewNotif);
        }

        onNotificationTypeChange() {
            const loader = this.loadingHelper.push('SAVING');
            this.gbEditTools.saveWidget().finally(() => {
                loader();
            });
        }
    },
};
